<template>
  <div>
    <AlertComponent
      v-if="setCloneDialog"
      :setCloneDialog="setCloneDialog"
      @hideCloneDialog="hideCloneDialog"
      @setWindow="showGridAfterClone"
      :numberOfOperation="selectedRowIds.length"
    ></AlertComponent>
    <AlertComponent
      v-if="setDeleteDialog"
      :setDeleteDialog="setDeleteDialog"
      @hideDeleteDialog="hideDeleteDialog"
      @setWindow="showGridAfterDelete"
      :numberOfOperation="selectedRowIds.length"
    ></AlertComponent>
    <OperationCreateComp
      v-if="showPopup"
      :showPopup="showPopup"
      @visibleDialog="update"
      :seamLengthUnit="seamLengthUnit"
      :ticketTex="ticketTex"
      :calculationEngineType="calculationEngineType"
      :isMultiComponentThreadEnabled="isMultiComponentThreadEnabled"
      @getOperationData="setStylesData"
      :consumptionData="consumptionData"
    ></OperationCreateComp>
    <EditComponent
      v-if="showEditPopup"
      :showEditPopup="showEditPopup"
      @visibleDialog="hideEditWindow"
      :operationId="selectedRowIds[0]"
      :seamLengthUnit="seamLengthUnit"
      :calculationEngineType="calculationEngineType"
      :isMultiComponentThreadEnabled="isMultiComponentThreadEnabled"
      :ticketTex="ticketTex"
      @getOperationData="setEditStylesData"
      @operationId="setOperationId"
      :consumptionData="consumptionData"
    ></EditComponent>
    <MultiEditComponent
      v-if="multipleFormat"
      :multipleFormat="multipleFormat"
      :selectedRowIds="selectedRowIds"
      :seamLengthUnit="seamLengthUnit"
      :calculationEngineType="calculationEngineType"
      :ticketTex="ticketTex"
      :selectedOperationCount="selectedOperationCount"
      @showGrid="showGridAfterMultiEdit"
      :consumptionData="consumptionData"
      :isMultiEditClicked="isMultipleEdit"
    ></MultiEditComponent>
    <div :class="['col-12', 'mb-4']">
      <div class="card bg-white" style="border-radius: 10px">
        <div class="card-body" :class="['card-body', { fullscreen: isMaximized }]">
          <div class="card-text">
            <div class="header mb-3">
              <div class="d-flex align-items-center gap-2">
                {{ $t("operationListComp.operationList") }}
                <div class="units">
                  {{ $t("operationListComp.uom") }}: {{ unitOfMeasurement }} {{ $t("operationListComp.uop") }}:
                  {{ unitOfPackage }} {{ ticketTex }}
                </div>
              </div>
              <div class="d-flex justify-content-end align-items-center gap-2" v-if="!isMaximized">
                <font-awesome-icon
                  icon="fa-solid fa-expand-alt"
                  @click="stylesData.length > 0 && toggleMaximize()"
                  :style="{
                    cursor: stylesData.length === 0 ? 'default' : 'pointer',
                    opacity: stylesData.length === 0 ? 0.4 : 1
                  }"
                />
              </div>
            </div>
            <div>
              <div class="buttons d-flex flex-wrap mb-3">
                <button
                  class="btn btn-sm btn-primary button"
                  style="width: 5rem; text-align: center"
                  @click="handleAdd"
                  :disabled="!isAddButtonDisabled"
                >
                  <span class="fa fa-plus"></span>{{ $t("operationListComp.add") }}
                </button>
                <button
                  class="btn btn-sm btn-primary button"
                  style="width: 5rem; text-align: center"
                  :disabled="(isMaximized && !multipleFormat && !isMultipleEdit) || disableButton"
                  @click="editOperationFunction"
                >
                  <span class="fas fa-edit" style="padding-right: 5px"></span>{{ $t("operationListComp.edit") }}
                </button>
                <button
                  class="btn btn-sm btn-primary button"
                  style="width: 6rem; text-align: center"
                  :disabled="disableButton"
                  @click="setCloneDialog = true"
                >
                  <span class="far fa-clone" style="padding-right: 5px"></span>{{ $t("operationListComp.duplicate") }}
                </button>
                <button
                  class="btn btn-sm btn-primary button"
                  style="width: 6rem; text-align: center"
                  @click="setDeleteDialog = true"
                  :disabled="disableButton"
                >
                  <span class="fa fa-trash" style="padding-right: 5px"></span>{{ $t("operationListComp.delete") }}
                </button>
              </div>
              <div>
                <div v-if="loadingGrid">
                  <GridLoading></GridLoading>
                </div>
                <div v-else class="flex-grow-1 overflow-auto operationGrid">
                  <kendo-grid
                    ref="operationsGrid"
                    :data-source="dataSource"
                    :columns="columns"
                    :sortable="true"
                    :column-menu="!isMaximized"
                    :filterable="
                      isMaximized
                        ? {
                            mode: 'menu',
                            extra: false,
                            operators: {
                              string: {
                                contains: 'Contains'
                              }
                            }
                          }
                        : true
                    "
                    :reorderable="true"
                    :selectable="'multiple'"
                    :persistSelection="true"
                    :selected-field="selectedField"
                    @change="onChange($event)"
                    :scrollable="false"
                  >
                  </kendo-grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Grid } from "@progress/kendo-grid-vue-wrapper";
import OperationCreateComp from "./OperationCreateComp.vue";
import { StyleOperationApi, ReportApi, StyleApi, StitchTypeApi, UserAdminSettingApi } from "@/api";
import EditComponent from "./EditComponent.vue";
import GridLoading from "./GridLoading.vue";
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import AlertComponent from "./AlertComponent.vue";
import MultiEditComponent from "./MultiEditComponent.vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ArialUnicodeMS from "../../../../public/ArialUnicodeMS.ttf";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import plausible from "@/core/plausible";
import { gsdV4StitchTypeNeedsBight } from "@/core/utils/V4BightStitchTypes";
export default defineComponent({
  name: "OperationListComp",
  props: {
    isAddButtonDisabled: {
      type: Boolean,
      default: false
    },
    ticketTex: null as any
  },
  emits: ["disableReport", "loadingGridChanged", "overallStatus", "allOperationStatusLength", "expandOperationList"],
  components: {
    "kendo-grid": Grid,
    OperationCreateComp,
    EditComponent,
    GridLoading,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    AlertComponent,
    MultiEditComponent
  },
  data() {
    const unitOfMeasurement = sessionStorage.getItem("seamLengthUnit");
    const seamLengthUnit = unitOfMeasurement == "Metric" ? 0 : 1;
    return {
      selectedField: "selected" as any,
      showPopup: false,
      disableButton: true,
      operationId: null as any,
      unitOfPackage: sessionStorage.getItem("packageUnitVal"),
      unitOfMeasurement,
      seamLengthUnit,
      disableReport: true,
      rows: [] as any,
      selectedRowIds: [] as any,
      setCloneDialog: false,
      setDeleteDialog: false,
      pageWidth: 0,
      totalPages: 1,
      currentPage: 1,
      selectedReportPrintingOption: "pdf",
      fontUrl: null as any,
      lang: null as any,
      customFont: "helvetica",
      dataSource: null as any,
      stylesData: [] as any,
      singleGarment: null as any,
      threadUsage: null as any,
      loading: false,
      showEditPopup: false,
      loadingGrid: false,
      multipleFormat: false,
      selectedOperationCount: 0,
      consumptionData: [] as any,
      toast: useToast(),
      operationStatus: "",
      color: "" as string,
      allOperationStatus: [] as any[],
      overallStatus: null as any,
      isMaximized: false,
      isMultipleEdit: false,
      fontStyleForPDF: "" as any,
      calculationEngineType: "",
      isMultiComponentThreadEnabled: false
    };
  },
  setup() {
    const styleOperationApi = new StyleOperationApi()!;
    const reportApi = new ReportApi()!;
    const styleApi = new StyleApi()!;
    const stitchTypeApi = new StitchTypeApi()!;
    const userAdminSettingApi = new UserAdminSettingApi()!;
    return {
      styleOperationApi,
      reportApi,
      styleApi,
      stitchTypeApi,
      userAdminSettingApi
    };
  },
  async created(): Promise<void> {
    this.$emit("expandOperationList", this.isMaximized);
    await this.getCalculationEngineType();
    if ((sessionStorage.getItem("styleId") as unknown as number) != null && sessionStorage.getItem("styleId") != "") {
      await this.getOperationList();
      this.getConsumptionData();
      const storedSelectedReportPrintingOption = localStorage.getItem("selectedReportPrintingOption");
      if (storedSelectedReportPrintingOption) {
        this.selectedReportPrintingOption = storedSelectedReportPrintingOption;
      }
    }
    this.$emit("disableReport", this.disableReport);
  },
  computed: {
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    },
    columns() {
      return [
        {
          selectable: true,
          width: "50px",
          title: " "
        },
        { field: "id", title: "", width: "50px", hidden: true },
        { field: "group", title: this.$t("operationListComp.group"), width: "70px" },
        {
          field: "descriptionText",
          title: this.$t("operationListComp.operationDescription"),
          format: "{0:c}",
          width: "140px",
          template: function (dataItem: any) {
            return dataItem.description;
          },
          encoded: false
        },
        { field: "stitchType", title: this.$t("operationListComp.stitchType"), width: "90px" },
        {
          field: "bight",
          title:
            this.seamLengthUnit == 0
              ? this.$t("operationListComp.bight") + "(mm)"
              : this.$t("operationListComp.bight") + "(inch)",
          width: "80px",
          hidden: this.isMaximized
        },
        {
          field: "seamLength",
          title:
            (this.seamLengthUnit == 0
              ? this.$t("operationListComp.seamLength") + "(Cm)"
              : this.$t("operationListComp.seamLength") + "(inch)") +
            (this.isV4CalculationEngine ? " / " + this.$t("editComponent.stitchCount") : ""),
          width: this.isV4CalculationEngine ? "180px" : "120px",
          hidden: this.isMaximized
        },
        {
          field: "rate",
          title:
            this.seamLengthUnit == 0
              ? this.$t("operationListComp.stitch") + "/3Cm"
              : this.$t("operationListComp.stitch") + "/inch",
          width: "80px",
          hidden: this.isMaximized
        },
        {
          field: "quantity",
          title: this.$t("operationListComp.row/Quantity"),
          width: "100px",
          hidden: this.isMaximized
        },
        { field: "machines", title: this.$t("operationListComp.machines"), width: "80px", hidden: this.isMaximized },
        this.isV4CalculationEngine
          ? {
              field: "numberOfPlies",
              title: this.$t("editComponent.numberOfPlies") as string,
              width: "120px",
              hidden: this.isMaximized
            }
          : {
              field: "seamThickness",
              title: this.$t("operationListComp.seamThickness") + "(mm)",
              width: "120px",
              hidden: this.isMaximized
            }
      ];
    }
  },
  watch: {
    isMaximized() {
      this.onExpand();
    }
  },
  methods: {
    async getCalculationEngineType(): Promise<void> {
      await this.userAdminSettingApi
        .apiSystemConfigurationGet()
        .then(res => {
          this.calculationEngineType = res.data.calculationEngineType?.defaultItem ?? "";
          this.isMultiComponentThreadEnabled = res.data.multiComponentThread === "true";
        })
        .catch(() => {
          this.calculationEngineType = "";
          this.isMultiComponentThreadEnabled = false;
        });
    },
    async onExpand() {
      this.$nextTick(() => {
        const grid = (this.$refs.operationsGrid as any)?.kendoWidget();
        if (!grid) return;

        grid.resize();
        grid.clearSelection();
        for (let id of this.selectedRowIds) {
          const row = grid.tbody.find(`tr`).filter((_: any, tr: any) => {
            const dataItem = grid.dataItem(tr);
            return dataItem && dataItem.id === id;
          });
          grid.select(row);
        }
      });
    },
    setDefaultEditOperation() {
      this.selectedRowIds = [];
      if (this.isMaximized) {
        this.showPopup = false;
        this.showEditPopup = true;
        const grid = (this.$refs["operationsGrid"] as any).kendoWidget();
        const firstDataItem = grid.dataSource.view()[0];

        if (firstDataItem && firstDataItem.id) {
          const row = grid.table.find("tr[data-uid='" + firstDataItem.uid + "']");
          grid.select(row);
        }

        this.selectedRowIds.push(firstDataItem.id);
        this.selectedOperationCount = this.selectedRowIds.length;
      }
    },
    toggleMaximize() {
      this.isMaximized = !this.isMaximized;
      this.setDefaultEditOperation();
    },
    setStylesData(): void {
      this.getOperationList();
    },
    async setEditStylesData() {
      await this.getOperationList();
      this.onExpand();
    },
    setOperationId(id: number): void {
      this.operationId = id;
    },
    async getConsumptionData(): Promise<void> {
      await this.stitchTypeApi
        .apiCalculateNeedlesLengthForAllStitchTypesGet(Number(sessionStorage.getItem("customSettingId")))
        .then(res => {
          this.consumptionData = res.data;
        });
    },
    async isOperationStitchNBLCDataExist(): Promise<void> {
      if ((sessionStorage.getItem("styleId") as unknown as number) == null || sessionStorage.getItem("styleId") == "") {
        this.disableReport = true;
      } else {
        await this.styleApi
          .apiSingleGarmentAndThreadUsageReportExistGet(sessionStorage.getItem("styleId") as unknown as number)
          .then(res => {
            if (res.data && this.overallStatus) this.disableReport = false;
            else this.disableReport = true;
          });
      }
      this.$emit("disableReport", this.disableReport);
    },
    async downloadSingleGarmentReport(includeCostElement: any, noOfGarmentsForSGC: any): Promise<void> {
      try {
        if (this.disableReport) {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }
        this.loadingGrid = true;
        this.$emit("loadingGridChanged", this.loadingGrid);
        const storedSelectedOption = localStorage.getItem("selectedReportPrintingOption");
        if (storedSelectedOption && storedSelectedOption == "csv") {
          await this.singleGarmentReport(includeCostElement, noOfGarmentsForSGC);
        } else {
          await this.singleGarmentPdf(includeCostElement, noOfGarmentsForSGC);
        }
        this.loadingGrid = false;
        this.$emit("loadingGridChanged", this.loadingGrid);
      } catch (e: any) {
        this.loadingGrid = false;
        this.$emit("loadingGridChanged", this.loadingGrid);
        this.toast.error((this.$t("operationListComp.reportDownloadError") as string) + ": " + e.message, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }
    },
    async downloadThreadGarmentReport(noOfGarmentsForSGC: any, noOfProductionLineForTU: any): Promise<void> {
      try {
        if (this.disableReport) {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }
        this.loadingGrid = true;
        this.$emit("loadingGridChanged", this.loadingGrid);
        const storedSelectedOption = localStorage.getItem("selectedReportPrintingOption");
        if (storedSelectedOption && storedSelectedOption == "csv") {
          await this.threadUsageReport(noOfGarmentsForSGC, noOfProductionLineForTU);
        } else {
          await this.threadUsagePdf(noOfGarmentsForSGC, noOfProductionLineForTU);
        }
        this.loadingGrid = false;
        this.$emit("loadingGridChanged", this.loadingGrid);
      } catch (e: any) {
        this.loadingGrid = false;
        this.$emit("loadingGridChanged", this.loadingGrid);
        this.toast.error((this.$t("operationListComp.reportDownloadError") as string) + ": " + e.message, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }
    },
    async handleAdd(): Promise<void> {
      if (this.isMaximized) {
        this.showEditPopup = false;
        this.multipleFormat = false;
      }
      this.isMaximized = true;
      this.showPopup = true;
      document.body.style.overflow = "hidden";
      this.getOperationList();
      this.getConsumptionData();
      this.disableButton = true;
    },
    update(value: boolean): void {
      this.disableButton = true;
      this.showPopup = value;
      document.body.style.overflow = "";
      this.isMaximized = false;
    },
    hideEditWindow(): void {
      this.getOperationList();
      this.showEditPopup = false;
      document.body.style.overflow = "";
      this.disableButton = true;
      this.isMaximized = false;
    },
    hideCloneDialog(value: boolean): void {
      this.setCloneDialog = value;
    },
    showGridAfterClone(value: boolean): void {
      this.setCloneDialog = value;
      this.cloneOperation();
      this.setDefaultEditOperation();
    },
    hideDeleteDialog(value: boolean): void {
      this.setDeleteDialog = value;
    },
    showGridAfterDelete(value: boolean): void {
      this.setDeleteDialog = value;
      this.deleteOperation();
    },
    async editOperationFunction(): Promise<void> {
      if (!this.isMaximized) {
        this.isMaximized = true;
      }
      this.getConsumptionData();
      if (this.selectedRowIds.length == 1) this.editOperation();
      else {
        this.multipleFormat = true;
        this.isMultipleEdit = true;
        this.showEditPopup = false;
        this.showPopup = false;
        document.body.style.overflow = "hidden";
      }
    },
    showGridAfterMultiEdit(value: boolean): void {
      this.multipleFormat = value;
      this.isMultipleEdit = value;
      this.isMaximized = value;
      this.getOperationList();
      this.disableButton = true;
    },
    onChange(e: { sender: { dataItem: (arg0: any) => any; select: () => any } }): void {
      this.selectedRowIds = [];
      this.isMultipleEdit = false;
      const grid = (this.$refs["operationsGrid"] as any).kendoWidget();
      const selectedRows = grid.select();
      const selectedData = Array.from(selectedRows).map((row: any) => {
        return grid.dataItem(row);
      });
      for (let dataItem of selectedData) {
        if (dataItem && dataItem.id) {
          this.selectedRowIds.push(dataItem.id);
        }
      }
      let selectedRowsLength = this.selectedRowIds.length;
      if (selectedRowsLength == 0) {
        this.disableButton = true;
      } else {
        if (selectedRowsLength == 1 && this.isMaximized) {
          this.editOperation();
        }
        if (selectedRowsLength > 1) {
          this.isMultipleEdit = true;
        }
        this.disableButton = false;
        this.selectedOperationCount = this.selectedRowIds.length;
      }
    },
    async editOperation(): Promise<void> {
      if (this.isMaximized && (this.showPopup || this.multipleFormat)) {
        this.showPopup = false;
        this.multipleFormat = false;
      }
      this.showEditPopup = true;
      document.body.style.overflow = "hidden";
    },
    async cloneOperation(): Promise<void> {
      this.loadingGrid = true;
      await this.styleOperationApi
        .apiCloneMultipleOperationsPost(this.selectedRowIds, sessionStorage.getItem("styleId") as unknown as number)
        .then((res: { data: any }) => {
          this.disableButton = true;
          if (res.data) {
            const errorMsg = this.$t("operationListComp.operationDuplicatedSuccessfully") as string;
            this.toast.success(errorMsg, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
          } else {
            this.toast.error(this.$t("operationListComp.errorInDuplicatingOperation") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          }
          this.getOperationList();
          this.loading = false;
        })
        .catch((e: any) => {
          this.loading = false;
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    async deleteOperation(): Promise<void> {
      this.loadingGrid = true;
      await this.styleOperationApi
        .apiDeleteMultipleOperationsDelete(this.selectedRowIds)
        .then(async res => {
          if (res.data) {
            this.toast.success(this.$t("operationListComp.operationDeletedSuccesfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            await this.getOperationList();
            this.disableButton = true;
            this.loadingGrid = false;
            if (this.isMaximized) {
              this.showEditPopup = false;
              this.showPopup = true;
              this.multipleFormat = false;
            }
          }
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          this.loadingGrid = false;
        });
    },
    async threadUsageReport(noOfGarmentsForSGC: any, noOfProdLines: any): Promise<void> {
      await this.reportApi
        .apiReportThreadUsageIdGet(
          sessionStorage.getItem("styleId") as unknown as number,
          sessionStorage.getItem("lang") as unknown as string,
          noOfGarmentsForSGC,
          noOfProdLines
        )
        .then(async e => {
          this.threadUsage = e.data;
          let fileName = "ThreadUsageReport.csv";
          this.downloadCsv(this.threadUsage, fileName);
          this.toast.success(this.$t("operationListComp.success") as string, {
            toastClassName: "custom-success-toast",
            timeout: 5000
          });
        })
        .catch(() => {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      plausible.trackEvent("ThreadUsage-Report", {
        props: { TenantName: sessionStorage.getItem("TenantName") ?? "" }
      });
    },
    downloadCsv: (function () {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      return function (data: any, fileName: any) {
        const blob = new Blob([data], { type: "octet/stream" }),
          url = globalThis.URL.createObjectURL(blob);
        a.href = "data:text/csv;charset=utf-16,%EF%BB%BF" + encodeURIComponent(data);
        a.download = fileName;
        a.click();
        globalThis.URL.revokeObjectURL(url);
      };
    })(),
    async singleGarmentReport(includeCostElement: any, noOfGarmentsForSGC: any): Promise<void> {
      await this.reportApi
        .apiReportSingleGarmentIdGet(
          sessionStorage.getItem("styleId") as unknown as number,
          sessionStorage.getItem("lang") as unknown as string,
          includeCostElement,
          noOfGarmentsForSGC
        )
        .then(async e => {
          this.singleGarment = e.data;
          let fileName = "SingleGarmentReport.csv";
          this.downloadCsv(this.singleGarment, fileName);
          this.toast.success(this.$t("operationListComp.success") as string, {
            toastClassName: "custom-success-toast",
            timeout: 5000
          });
        })
        .catch(e => {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      plausible.trackEvent("SGC-Report", { props: { TenantName: sessionStorage.getItem("TenantName") ?? "" } });
    },
    getStitchDetails(x: any) {
      switch (x.stitchTypeCode) {
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042": {
          x.bight = 0;
          x.seamLength = 0;
          x.seamThikness = 0;
          x.rate = 0;
          break;
        }
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417": {
          x.bight = 0;
          x.quantity = 0;
          x.seamThikness = 0;
          break;
        }
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043": {
          x.bight = 0;
          x.rate = 0;
          x.seamThikness = 0;
          break;
        }
        case "1015":
        case "109":
        case "3015":
        case "3045":
        case "4041":
        case "4045": {
          x.bight = 0;
          x.seamThikness = 0;
          break;
        }
        case "302":
        case "303":
        case "304":
        case "305":
        case "306":
        case "307":
        case "308":
        case "309":
        case "310":
        case "311":
        case "312":
        case "313":
        case "314":
        case "320":
        case "321":
        case "322":
        case "323":
        case "324":
        case "325":
        case "326":
        case "327":
        case "328":
        case "402":
        case "403":
        case "408":
        case "4083":
        case "410":
        case "501":
        case "502":
        case "503":
        case "505":
        case "506":
        case "507":
        case "508":
        case "509":
        case "512":
        case "515":
        case "601":
        case "604":
        case "606":
        case "609": {
          x.quantity = 0;
          x.seamThikness = 0;
          break;
        }
        case "4012G": {
          x.rate = 0;
          x.bight = 0;
          break;
        }
        case "301":
        case "319":
        case "401":
        case "401A": {
          x.bight = 0;
          break;
        }
        case "406":
        case "407":
        case "504":
        case "514":
        case "602":
        case "605":
        case "607K":
        case "516":
        case "607": {
          x.quantity = 0;
          break;
        }
        default: {
          break;
        }
      }
    },
    assignStyleOperation(x: any, color: any, status: any) {
      let styleOperation = {
        id: x.id,
        group: x.group,
        descriptionText: x.description,
        description: `<div style="display: flex; gap: 10px; align-items: center;"><span style="width:10px; height:10px; background-color:${this.color}; border-radius:50%; display:inline-block;vertical-align: middle;flex-shrink: 0;"  title="${this.operationStatus}"></span><span>${x.description}
                </span></div>`,
        stitchType: x.stitchTypeCode,
        bight: x.bight == 0 ? "" : x.bight,
        seamLength: x.seamLength == 0 ? "" : x.seamLength,
        rate: x.rate == 0 ? "" : x.rate,
        quantity: x.quantity == 0 ? "" : x.quantity,
        machines: x.machines,
        seamThickness: x.seamThikness == 0 ? "" : x.seamThikness,
        numberOfPlies: x.numberOfPlies ?? ""
      };
      return styleOperation;
    },
    async getOperationList(): Promise<void> {
      this.loadingGrid = true;
      await this.styleOperationApi
        .apiGetOperationsGet(sessionStorage.getItem("styleId") as unknown as number, this.seamLengthUnit)
        .then(async res => {
          const operations: any[] = [];
          const operationStatuses: any[] = [];
          for (const x of res.data) {
            const savedBight = x.bight;
            this.getStitchDetails(x);
            // GSD V4: the listed stitch types keep their saved Bight, whatever the switch above cleared.
            if (this.isV4CalculationEngine && gsdV4StitchTypeNeedsBight(x.stitchTypeCode)) {
              x.bight = savedBight;
            }
            let statusComplete = x.isCompleteOperation ? "Complete" : "Incomplete";
            this.color = x.isCompleteOperation ? "#08c75e" : "red";
            this.operationStatus = statusComplete;
            operationStatuses.push(x.isCompleteOperation);

            operations.push(this.assignStyleOperation(x, this.color, this.operationStatus));
          }
          this.stylesData = operations;
          this.allOperationStatus = operationStatuses;
          this.overallStatus =
            this.allOperationStatus.length > 0 ? this.allOperationStatus.every(status => status === true) : null;
          this.$emit("overallStatus", this.overallStatus);
          this.$emit("allOperationStatusLength", this.allOperationStatus.length);
          this.dataSource = {
            data: this.stylesData,
            schema: {
              model: {
                id: "id"
              }
            }
          };
          await this.isOperationStitchNBLCDataExist();
        })
        .finally(() => {
          this.loadingGrid = false;
        });
    },
    async singleGarmentPdf(includeCostElement: any, noOfGarmentsForSGC: any): Promise<void> {
      const dataItemId = sessionStorage.getItem("styleId") as unknown as number;
      await this.reportApi
        .apiReportSingleGarmentPdfIdGet(dataItemId, includeCostElement, noOfGarmentsForSGC)
        .then(async res => {
          const doc = new jsPDF();
          this.lang = sessionStorage.getItem("lang");
          this.fontStyleForPDF = this.lang == "Chinese" ? "normal" : "bold";
          if (this.lang != undefined && this.lang != "English") {
            this.customFont = "CustomFont";
            doc.addFont(ArialUnicodeMS, "CustomFont", "normal");
          }
          this.generateStyleHeader(doc, res, true);
          this.generateThreadConsumptionSummary(doc, res, includeCostElement);
          this.generateOperationSummary(doc, res, noOfGarmentsForSGC);
          // Notes stack under the operation table: wastage note, then the quantity note, then
          // "Last edited by". Each returns the Y the next block starts from; undefined means nothing
          // was drawn, so the block below keeps its own default position.
          const wastageNoteY = this.generateThreadWastageNote(doc, res, !this.isV4CalculationEngine);
          const noteBottomY =
            noOfGarmentsForSGC > 0
              ? this.generateFooterNoteForSGCWithQuantity(doc, noOfGarmentsForSGC, wastageNoteY)
              : wastageNoteY;
          this.generateLastEditedBy(doc, res, noteBottomY);
          this.generateFooter(doc, this.totalPages);
          doc.save(res.data.styleDetails?.name + "_SGC.pdf");
        })
        .catch(e => {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      plausible.trackEvent("SGC-Report", {
        props: { TenantName: sessionStorage.getItem("TenantName") ?? "" }
      });
    },
    async threadUsagePdf(noOfGarmentsForSGC: any, noOfProductionLineForTU: any): Promise<void> {
      const dataItemId = sessionStorage.getItem("styleId") as unknown as number;
      await this.reportApi
        .apiReportThreadGarmentPdfIdGet(dataItemId, noOfGarmentsForSGC, noOfProductionLineForTU)
        .then(async res => {
          const doc = new jsPDF();
          this.lang = sessionStorage.getItem("lang");
          this.fontStyleForPDF = this.lang == "Chinese" ? "normal" : "bold";
          if (this.lang != undefined && this.lang != "English") {
            this.customFont = "CustomFont";
            doc.addFont(ArialUnicodeMS, "CustomFont", "normal");
          }
          this.generateStyleHeader(doc, res, false);
          this.generateThreadRequirement(doc, res, noOfGarmentsForSGC, noOfProductionLineForTU);
          this.generateOperationSummaryForThreadUsage(doc, res);
          this.generateTotalUnusedThread(doc, res);
          this.generateLastEditedBy(doc, res);
          this.generateFooter(doc, this.totalPages);
          doc.save(res.data.styleDetails?.name + "_TU.pdf");
        })
        .catch(e => {
          this.toast.error(this.$t("operationListComp.reportDownloadError") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
      plausible.trackEvent("SGC-Report", {
        props: { TenantName: sessionStorage.getItem("TenantName") ?? "" }
      });
    },
    generateStyleHeader(doc: any, res: any, isSingleGarmentReportPdf: boolean): void {
      const today = new Date();
      const formattedDate = today.toLocaleDateString("en-GB");
      this.pageWidth = doc.internal.pageSize.getWidth();
      const imageWidth = 50;
      const imageHeight = 8;
      const imageX = doc.internal.pageSize.getWidth() - imageWidth - 15;
      const imageY = 10;
      const maxImageWidth = doc.internal.pageSize.getWidth() - imageX - 10;
      const imageURL = "logo.png";
      doc.addImage(imageURL, "PNG", imageX + 3, imageY, Math.min(imageWidth, maxImageWidth) + 5, imageHeight);
      doc.setFontSize(12);
      if (this.lang == "English" || this.lang == "undefined" || this.lang == null) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont(this.customFont);
      }
      if (isSingleGarmentReportPdf) {
        doc.text(this.$t("styleGrid.singleGarmentReport"), 5, 18);
      } else {
        doc.text(this.$t("styleGrid.threadUsageReport"), 5, 18);
      }
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, 25, 205, 25);
      const styleHeaderData = [
        [
          { content: this.$t("styleGrid.style") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.name,
          { content: this.$t("styleGrid.customer") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.customer,
          { content: this.$t("styleGrid.createdBy") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.createdBy
        ],
        [
          { content: this.$t("styleGrid.productCategory") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.productCategory,
          { content: this.$t("styleGrid.product") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.productType,
          { content: this.$t("styleGrid.createdDate") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          formattedDate
        ],
        [
          { content: this.$t("styleGrid.fabricWeight") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.weightType,
          { content: this.$t("styleGrid.color") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.color == "" ? "-" : res.data.styleDetails?.color,
          { content: this.$t("styleGrid.size") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.size == "" ? "-" : res.data.styleDetails?.size
        ],
        [
          { content: this.$t("styleGrid.description") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          { content: res.data.styleDetails?.description == "" ? "-" : res.data.styleDetails?.description, colSpan: 5 }
        ]
      ];
      autoTable(doc, {
        body: styleHeaderData,
        startY: 30,
        headStyles: { font: "arial-unicode-ms-bold" },
        theme: "plain",
        styles: { overflow: "linebreak", font: this.customFont },
        margin: { left: 5, right: 5 }
      });
    },

    generateThreadConsumptionBody(res: any): any {
      let threadConsumptionSummaryData: any = [];
      for (let summary of res.data.threadConsumptionSummaries ?? []) {
        const rowData = [
          summary.brand,
          { content: summary.ticketTex, styles: { halign: "right" } },
          summary.shade == ""
            ? { content: "-", styles: { cellPadding: { left: 45, top: 2 } } }
            : { content: summary.shade, styles: { cellPadding: { left: 40, top: 2 } } },
          {
            content: summary.totalThreadConsumption.toFixed(2),
            styles: { halign: "right" }
          }
        ];
        if (summary.cost != null) {
          rowData.push({
            content: summary.cost,
            styles: { halign: "right" }
          });
        }
        threadConsumptionSummaryData.push(rowData);
      }
      return threadConsumptionSummaryData;
    },
    generateThreadConsumptionSummary(doc: any, res: any, includeCostElement: any): void {
      let threadConsumptionSummaryData = this.generateThreadConsumptionBody(res);
      doc.line(5, doc.lastAutoTable.finalY + 2, 205, doc.lastAutoTable.finalY + 2);
      doc.text(this.$t("styleGrid.threadConsumptionSummary"), 5, doc.lastAutoTable.finalY + 10);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable.finalY + 14, 205, doc.lastAutoTable.finalY + 14);
      const unit = sessionStorage.getItem("seamLengthUnit") == "Metric" ? "(m)" : "(y)";
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex" ? this.$t("operationCreateComp.tex") : this.$t("styleGrid.ticket");
      const header = [
        [this.$t("styleGrid.brand"), tktTex, this.$t("styleGrid.shade"), this.$t("styleGrid.totalThread") + unit]
      ];

      const totalRow = [
        this.$t("styleGrid.total"),
        "",
        "",
        { content: res.data.totalConsumption as number, styles: { halign: "right" } }
      ];
      if (includeCostElement) {
        header[0].push(this.$t("styleGrid.cost") + " (" + res.data.currencyUnit + ")");
        totalRow.push({ content: res.data.totalCost as number, styles: { halign: "right" } });
      }
      threadConsumptionSummaryData.push(totalRow);
      autoTable(doc, {
        head: header,
        headStyles: { textColor: "black", fillColor: "white", font: "arial-unicode-ms-bold" },
        body: threadConsumptionSummaryData,
        theme: "plain",
        margin: { left: 5, right: 5 },
        styles: { overflow: "linebreak", font: this.customFont },
        columnStyles: {
          1: { cellWidth: includeCostElement ? this.pageWidth / 6 : this.pageWidth / 5 },
          ...(includeCostElement ? { [header[0].length - 1]: { halign: "right" } } : {})
        },
        startY: doc.lastAutoTable.finalY + 16,
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            if (
              data.column.index == 3 ||
              data.column.index == 1 ||
              (includeCostElement && data.column.index == header[0].length - 1)
            ) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
            if (data.column.index == 2) {
              const { styles } = data.cell;
              styles.cellPadding = { left: 40, top: 2 };
            }
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index === threadConsumptionSummaryData.length - 1) {
              const { styles } = data.cell;
              styles.fontStyle = this.fontStyleForPDF;
            }
            if (data.row.index >= 0 && data.row.index != threadConsumptionSummaryData.length - 1) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    generateTotalUnusedThreadBody(res: any): any {
      let totalUnusedThread: any[] = [];
      for (let summary of res.data.totalUnusedThread?.unusedThreadItems ?? []) {
        const rowData = [
          summary.article,
          summary.brand,
          {
            content: summary.ticketTex,
            styles: { halign: "right", cellPadding: { right: 20, top: 2 } }
          },
          summary.shade == "" ? { content: "-", styles: { cellPadding: { left: 5, top: 2 } } } : summary.shade,
          { content: summary.threadConsumption.toFixed(2), styles: { halign: "right" } }
        ];
        totalUnusedThread.push(rowData);
      }
      return totalUnusedThread;
    },
    styleHeadCell(data: any, styles: any) {
      if (data.column.index == 4) {
        styles.halign = "right";
      }
      if (data.column.index == 2) {
        styles.cellPadding = { right: 20, top: 2 };
        styles.halign = "right";
      }
      if (data.column.index == 0 && data.row.index == 0) {
        styles.fontSize = 12;
      }
    },
    generateTotalUnusedThread(doc: any, res: any): void {
      let totalUnusedThread = this.generateTotalUnusedThreadBody(res);
      doc.setFont(this.customFont);
      doc.setFontSize(12);
      doc.setFont(this.customFont);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      const lenthUnit = sessionStorage.getItem("packageUnitVal") == "Metric" ? "(m)" : "(y)";
      const totalUnusedThreadVal = this.$t("styleGrid.totalUnusedThread");
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex" ? this.$t("operationCreateComp.tex") : this.$t("styleGrid.ticket");
      const header = [
        [{ content: totalUnusedThreadVal + "", colSpan: 5 }],
        [
          this.$t("styleGrid.article"),
          this.$t("styleGrid.brand"),
          tktTex,
          this.$t("styleGrid.shade"),
          this.$t("styleGrid.length") + " " + lenthUnit
        ]
      ];
      const partPackages = [
        this.$t("styleGrid.partPackages"),
        "",
        "",
        "",
        { content: res.data.totalUnusedThread?.partPackages.toFixed(2), styles: { halign: "right" } }
      ];
      const extraPackages = [
        this.$t("styleGrid.extraPackages"),
        "",
        "",
        "",
        { content: res.data.totalUnusedThread?.extraPackages.toFixed(2), styles: { halign: "right" } }
      ];
      const totalUnusedThreadMetric = [
        { content: totalUnusedThreadVal + " " + lenthUnit, colSpan: 4 },
        { content: res.data.totalUnusedThread?.totalUnuseThread.toFixed(2), styles: { halign: "right" } }
      ];
      totalUnusedThread.push(partPackages, extraPackages, totalUnusedThreadMetric);
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        body: totalUnusedThread,
        theme: "plain",
        margin: { left: 5, right: 5 },
        styles: { font: this.customFont },
        startY: doc.lastAutoTable.finalY + 2,
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            const { styles } = data.cell;
            this.styleHeadCell(data, styles);
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index >= totalUnusedThread.length - 3) {
              const { styles } = data.cell;
              styles.fontStyle = this.fontStyleForPDF;
              data.cell.styles.textColor = "black";
            }
            if (
              data.row.index >= 0 &&
              data.row.index != totalUnusedThread.length - 3 &&
              data.row.index != totalUnusedThread.length - 2 &&
              data.row.index != totalUnusedThread.length - 1
            ) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        }
      });
    },
    generateThreadRequirement(doc: any, res: any, noOfGarmentsForSGC: any, noOfProductionLineForTU: any): void {
      let threadRequirement: any[][] = [];
      for (let summary of res.data.threaRequirementDetails ?? []) {
        const rowData = [
          summary.brand,
          { content: summary.article, styles: { halign: "right" } },
          { content: summary.ticketTex, styles: { halign: "right" } },
          summary.shade == "" ? { content: "-", styles: { halign: "center" } } : summary.shade,
          { content: summary.quantity, styles: { halign: "right" } },
          summary.unit,
          { content: summary.price.toFixed(2), styles: { halign: "right" } },
          {
            content: summary.cost.toFixed(2) as unknown as string,
            styles: { halign: "right" }
          }
        ];
        threadRequirement.push(rowData);
      }
      doc.setFont(this.customFont);
      doc.setFontSize(12);
      doc.line(5, doc.lastAutoTable.finalY + 2, 205, doc.lastAutoTable.finalY + 2);
      doc.text(this.$t("styleGrid.threadRequirement"), 5, doc.lastAutoTable.finalY + 10);
      let boldTextWidth = doc.getTextWidth(this.$t("styleGrid.threadRequirement"));
      let threadRequirementHeaderTxt = ((((noOfGarmentsForSGC as unknown as string) +
        this.$t("styleGrid.garments")) as unknown as string) +
        noOfProductionLineForTU +
        this.$t("styleGrid.team")) as unknown as string;
      doc.text(threadRequirementHeaderTxt, 5 + boldTextWidth, doc.lastAutoTable.finalY + 10);
      let allowanceHeaderTxt = this.$t("styleGrid.allowance") + " % :";
      boldTextWidth = doc.getTextWidth(allowanceHeaderTxt);
      doc.text(allowanceHeaderTxt, 195 - boldTextWidth, doc.lastAutoTable.finalY + 10);
      doc.text(" " + res.data.styleDetails?.allowance, 195, doc.lastAutoTable.finalY + 10);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable.finalY + 15, 205, doc.lastAutoTable.finalY + 15);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const header = [
        [
          this.$t("styleGrid.brand"),
          this.$t("styleGrid.article"),
          tktTex,
          this.$t("styleGrid.shade"),
          this.$t("styleGrid.quantity"),
          this.$t("styleGrid.unit"),
          this.$t("styleGrid.price"),
          this.$t("styleGrid.cost") + " (" + res.data.currencyUnit + ")"
        ]
      ];
      const totalCost = [
        { content: this.$t("styleGrid.total"), styles: { fontStyle: this.fontStyleForPDF }, colSpan: 7 },
        { content: res.data.totalThreadCost.toFixed(2), styles: { halign: "right" } }
      ];
      const avgCost = [
        {
          content: this.$t("styleGrid.avgCostOfThreadPerGarment"),
          styles: { fontStyle: this.fontStyleForPDF },
          colSpan: 7
        },
        { content: res.data.averageThreadCost.toFixed(2), styles: { halign: "right" } }
      ];
      threadRequirement.push(totalCost, avgCost);
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        body: threadRequirement,
        theme: "plain",
        margin: { left: 5, right: 5 },
        startY: doc.lastAutoTable.finalY + 20,
        styles: { font: this.customFont },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            if (
              data.column.index == 1 ||
              data.column.index == 2 ||
              data.column.index == 4 ||
              data.column.index == 6 ||
              data.column.index == 7
            ) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index >= threadRequirement.length - 2) {
              const { styles } = data.cell;
              styles.fontStyle = this.fontStyleForPDF;
              data.cell.styles.textColor = "black";
            }
            if (
              data.row.index >= 0 &&
              data.row.index != threadRequirement.length - 2 &&
              data.row.index != threadRequirement.length - 1
            ) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    // Draws the note asked for by reports whose thread figures already include wastage (the Seamworks
    // engine ones), directly under the operation table and above every other note. Returns the Y the
    // next block starts from, or undefined when nothing was drawn so callers keep their own defaults.
    generateThreadWastageNote(doc: any, res: any, show: boolean): number | undefined {
      if (!show) return undefined;
      let y = doc.lastAutoTable?.finalY + 14;
      if (res.data.isTensionSettingsChanged) y += 8;
      // Restored afterwards so the italic 10pt does not leak into the notes drawn below this one.
      const previousFont = doc.getFont();
      const previousFontSize = doc.getFontSize();
      // Only helvetica has italic letterforms. The bundled Unicode font has none, and jsPDF would
      // silently swap in Times-Italic, which cannot draw the non-Latin scripts.
      doc.setFont(this.customFont, this.customFont == "helvetica" ? "italic" : "normal");
      doc.setFontSize(10);
      doc.text(this.$t("styleGrid.threadWastageNote"), 5, y);
      doc.setFont(previousFont.fontName, previousFont.fontStyle);
      doc.setFontSize(previousFontSize);
      // 8mm is what the existing code already allows per note line under the table.
      return y + 8;
    },
    generateFooterNoteForSGCWithQuantity(doc: any, noOfGarmentsForSGC: any, startY?: number): number {
      const footerNote =
        this.$t("styleGrid.footerNoteForSGCWithQuantityPart1") +
        " " +
        noOfGarmentsForSGC +
        " " +
        this.$t("styleGrid.footerNoteForSGCWithQuantityPart2");
      doc.setFontSize(12);
      const verticalSpace = 20;
      const lastY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 0;
      const y = startY ?? lastY + verticalSpace;

      const pageWidth = doc.internal.pageSize.getWidth();
      const padding = 12;
      const maxWidth = pageWidth - 2 * padding;

      const lines = doc.splitTextToSize(footerNote, maxWidth);
      doc.text(lines, padding, y, { align: "left" });
      return y + lines.length * 6;
    },
    generateFooter(doc: jsPDF, totalPages: number): void {
      doc.setFont("helvetica", "normal");
      const currentDate = new Date();
      const options: any = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      };
      const printedDate = "Date Printed: " + currentDate.toLocaleString("en-US", options);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const footerX = doc.internal.pageSize.getWidth() / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${totalPages}`, footerX, footerY, { align: "center" });
        doc.text(printedDate, doc.internal.pageSize.getWidth() - 10, footerY, { align: "right" });
      }
    },
    // Renders "Last edited By" + edited date/time in the report body, left-aligned. Defaults to just
    // below the last content table; pass startY to place it below other content drawn after the table
    // (e.g. the SGC quantity note) so the blocks don't overlap.
    generateLastEditedBy(doc: any, res: any, startY?: number): void {
      const lastEditedBy = res?.data?.styleDetails?.editedBy;
      const editedDate = res?.data?.styleDetails?.editedDate;
      let y = startY ?? doc.lastAutoTable?.finalY + 14;
      if (startY === undefined && res.data.isTensionSettingsChanged) y += 8;
      // Page footer is drawn at pageHeight - 10; if the two text lines (y and y + 5) would
      // enter that reserved strip, move the block to a fresh page and count it for the footer.
      const footerReserveY = doc.internal.pageSize.getHeight() - 15;
      if (y + 5 > footerReserveY) {
        doc.addPage();
        this.currentPage = doc.internal.getNumberOfPages();
        this.totalPages = this.currentPage;
        y = 15;
      }
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      const lastEditedByLabel = (this.$t("styleGrid.lastEditedBy") as unknown as string) + ":";
      doc.text(lastEditedByLabel, 5, y);
      const valueX = 5 + doc.getTextWidth(lastEditedByLabel) + 3;
      doc.text(lastEditedBy ?? "", valueX, y);
      doc.text(editedDate ?? "", valueX, y + 5);
    },
    createOperationSummaryRow(summary: any, index: any, styleOp: any) {
      if (index != 0) {
        return [
          "",
          "",
          "",
          "",
          ...(this.isV4CalculationEngine ? ["", ""] : []),
          styleOp.needleName,
          styleOp.brand,
          { content: styleOp.ticketTex, styles: { halign: "center" } },
          styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade,
          { content: styleOp.threadConsumption, styles: { halign: "center" } }
        ];
      }
      const operation = summary.description;
      return [
        { content: operation, rowSpan: summary.styleOperations.length },
        summary.bight === 0
          ? { content: "-", styles: { halign: "right", cellPadding: { right: 6, top: 2 } } }
          : { content: summary.bight.toFixed(2), styles: { halign: "right" } },
        { content: summary.seamLength, styles: { halign: "right" } },
        summary.rate === 0
          ? { content: "-", styles: { halign: "center" } }
          : { content: summary.rate, styles: { halign: "right" } },
        summary.stitchTypeCode,
        ...(this.isV4CalculationEngine
          ? [
              { content: summary.wastagePerSeam ?? "-", styles: { halign: "right" } },
              summary.needleDistance === 0 || summary.needleDistance == null
                ? { content: "-", styles: { halign: "center" } }
                : { content: summary.needleDistance, styles: { halign: "right" } }
            ]
          : []),
        styleOp.needleName,
        styleOp.brand,
        { content: styleOp.ticketTex, styles: { halign: "center" } },
        styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade,
        { content: styleOp.threadConsumption, styles: { halign: "center" } }
      ];
    },
    generateOperationSummaryBody(res: any): any {
      let operationSummaryData: any[][] = [];
      for (let summary of res.data.operationSummary ?? []) {
        for (let [index, styleOp] of summary.styleOperations.entries()) {
          let rowData = this.createOperationSummaryRow(summary, index, styleOp);
          operationSummaryData.push(rowData.slice());
        }
      }
      operationSummaryData = operationSummaryData
        .map(subArray => subArray.filter(element => element !== undefined))
        .filter(subArray => subArray.length > 0);
      return operationSummaryData;
    },
    generateOperationSummary(doc: any, res: any, noOfGarmentsForSGC: any): void {
      let operationSummaryData = this.generateOperationSummaryBody(res);
      doc.text(this.$t("styleGrid.operationSummary"), 5, doc.lastAutoTable.finalY + 8);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable.finalY + 13, 205, doc.lastAutoTable.finalY + 13);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const isMetric = sessionStorage.getItem("seamLengthUnit") == "Metric";
      const lengthUnit = isMetric ? " (cm)" : " (in)";
      const lengthLabel = isMetric ? this.$t("styleGrid.length") + " (cm)" : this.$t("styleGrid.length") + " (in)";
      const header = [
        [
          this.$t("styleGrid.operation"),
          sessionStorage.getItem("seamLengthUnit") == "Metric"
            ? this.$t("styleGrid.bight") + " (mm)"
            : this.$t("styleGrid.bight") + " (in)",
          this.isV4CalculationEngine
            ? this.$t("operationListComp.seamLength") + lengthUnit + " / " + this.$t("editComponent.stitchCount")
            : lengthLabel,
          sessionStorage.getItem("seamLengthUnit") == "Metric" ? "SP /3cm" : "SP /in",
          this.$t("styleGrid.stitch"),
          ...(this.isV4CalculationEngine
            ? [
                sessionStorage.getItem("seamLengthUnit") == "Metric"
                  ? this.$t("editComponent.wastagePerSeam") + " (cm)"
                  : this.$t("editComponent.wastagePerSeam") + " (in)",
                this.$t("editComponent.needleDistance")
              ]
            : []),
          this.$t("styleGrid.component"),
          this.$t("styleGrid.brand"),
          tktTex,
          this.$t("styleGrid.shade"),
          sessionStorage.getItem("seamLengthUnit") == "Metric"
            ? this.$t("styleGrid.thread") + " (cm)"
            : this.$t("styleGrid.thread") + " (in)"
        ]
      ];
      autoTable(doc, {
        head: header,
        headStyles: { textColor: "black", fillColor: "white", font: "arial-unicode-ms-bold" },
        theme: "plain",
        body: operationSummaryData,
        startY: doc.lastAutoTable.finalY + 16,
        styles: { overflow: "linebreak", font: this.customFont },
        columnStyles: {
          0: { cellWidth: this.pageWidth / 7 }
        },
        margin: { left: 5, right: 5 },
        didParseCell: data => {
          if (data.section === "body" && data.cell.section === "body") {
            data.cell.styles.textColor = "#58595B";
          }
          if (data.section == "head" && data.row.section == "head") {
            const rightAlignedHeaderCols = this.isV4CalculationEngine ? [1, 2, 3, 5, 6] : [1, 2, 3];
            if (rightAlignedHeaderCols.includes(data.column.index)) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.column.index == 0) {
              const { doc, cell } = data;
              doc.setDrawColor(192, 192, 192);
              doc.setLineWidth(0.3);
              doc.line(cell.x, cell.y + cell.height, 205, cell.y + cell.height);
            }
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
      if (res.data.isTensionSettingsChanged) {
        doc.setFont(this.customFont, this.fontStyleForPDF);
        doc.setFontSize(12);
        doc.text("* -  " + this.$t("styleGrid.tensionSettingOfStitchTypeChanged"), 5, doc.lastAutoTable.finalY + 12);
      }
    },
    createOperationSummaryForThreadUsageRow(summary: any, index: any, styleOp: any) {
      if (index === 0) {
        const rowData: any[] = [
          { content: summary.description, rowSpan: summary.styleOperations.length },
          { content: summary.stitchTypeCode, styles: { halign: "right" } },
          { content: summary.machines, styles: { halign: "right" } },
          ...(this.isV4CalculationEngine
            ? [
                { content: summary.wastagePerSeam ?? "-", styles: { halign: "right" } },
                summary.needleDistance === 0 || summary.needleDistance == null
                  ? { content: "-", styles: { halign: "center" } }
                  : { content: summary.needleDistance, styles: { halign: "right" } }
              ]
            : []),
          summary.styleOperations?.[0].needleName,
          summary.styleOperations?.[0].brand,
          { content: summary.styleOperations?.[0].threadQuantity, styles: { halign: "right" } },
          { content: summary.styleOperations?.[0].article, styles: { halign: "right" } },
          summary.styleOperations?.[0].ticketTex,
          summary.styleOperations?.[0].shade == ""
            ? { content: "-", styles: { halign: "center" } }
            : summary.styleOperations?.[0].shade
        ];
        return rowData;
      } else {
        const rowData1: any[] = [
          "",
          "",
          ...(this.isV4CalculationEngine ? ["", ""] : []),
          styleOp.needleName,
          styleOp.brand,
          { content: styleOp.threadQuantity, styles: { halign: "right" } },
          { content: styleOp.article, styles: { halign: "right" } },
          styleOp.ticketTex,
          styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade
        ];
        return rowData1;
      }
    },
    generateOperationSummaryForThreadUsage(doc: any, res: any): void {
      let operationSummaryData: any[][] = [];
      for (let summary of res.data.operationSummary ?? []) {
        for (let [index, styleOp] of summary.styleOperations.entries()) {
          let rowData = this.createOperationSummaryForThreadUsageRow(summary, index, styleOp);
          operationSummaryData.push(rowData.slice());
        }
      }
      operationSummaryData = operationSummaryData
        .map(subArray => subArray.filter(element => element !== undefined))
        .filter(subArray => subArray.length > 0);
      doc.text(this.$t("styleGrid.operationSummary"), 5, doc.lastAutoTable.finalY + 8);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable.finalY + 12, 205, doc.lastAutoTable.finalY + 12);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const header = [
        [
          this.$t("styleGrid.operation"),
          this.$t("styleGrid.stitch"),
          this.$t("styleGrid.machines"),
          ...(this.isV4CalculationEngine
            ? [
                sessionStorage.getItem("seamLengthUnit") == "Metric"
                  ? this.$t("editComponent.wastagePerSeam") + " (cm)"
                  : this.$t("editComponent.wastagePerSeam") + " (in)",
                this.$t("editComponent.needleDistance")
              ]
            : []),
          this.$t("styleGrid.component"),
          this.$t("styleGrid.brand"),
          this.$t("styleGrid.quantity"),
          this.$t("styleGrid.article"),
          tktTex,
          this.$t("styleGrid.shade")
        ]
      ];
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        theme: "plain",
        body: operationSummaryData,
        startY: doc.lastAutoTable.finalY + 15,
        margin: { left: 5, right: 5 },
        styles: { font: this.customFont },
        columnStyles: {
          0: { cellWidth: this.pageWidth / 7 }
        },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            const rightAlignedHeaderCols = this.isV4CalculationEngine ? [1, 2, 3, 4, 7, 8] : [1, 2, 5, 6];
            if (rightAlignedHeaderCols.includes(data.column.index)) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
          if (data.section === "body" && data.cell.section === "body") {
            data.cell.styles.textColor = [112, 112, 112];
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.column.index == 0) {
              const { doc, cell } = data;
              doc.setDrawColor(192, 192, 192);
              doc.setLineWidth(0.3);
              doc.line(cell.x, cell.y + cell.height, 205, cell.y + cell.height);
            }
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    handleDropdownChange(): void {
      localStorage.setItem("selectedReportPrintingOption", this.selectedReportPrintingOption);
    }
  }
});
</script>
<style lang="scss" scoped>
button {
  padding: 2px;
  display: inline;
  text-align: left;
  margin-right: 5px;
  border-radius: 5px;
  background-color: #0054a6 !important;
  color: white;
}
.iconStyle {
  font-size: large;
  margin: 2px;
}
.units {
  font-size: 12px;
  color: #767474;
  margin-right: 9rem;
}
.b-toaster {
  z-index: 99999 !important;
}
.save {
  color: #fff;
  background-color: #0054a6;
  border-radius: 5px;
}
.cancel {
  border-radius: 5px;
}
.operationGrid {
  max-height: 500px;
  overflow-y: auto;
}
.fullscreen .operationGrid {
  height: calc(100vh - 125px);
  max-height: none;
  overflow-y: auto;
}
:deep .k-grid-header {
  position: sticky !important;
  top: 0;
}
.buttonIndicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}
.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 45vw;
  height: 100vh;
  z-index: 1050;
  background: white;
  overflow: auto;
  padding: 20px;
}
</style>
